const mobileMax = 480;
const tabletMax = 1024;

export const isMobile = () => window.innerWidth <= mobileMax;

export const isTablet = () => window.innerWidth > mobileMax && window.innerWidth <= tabletMax;

export const isDesktop = () => !isMobile() && !isTablet();
